// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 76 ? "common" : chunkId) + "." + {"76":"90ffa9f0","419":"4f562665","471":"947d4f7a","507":"c2b485ef","795":"c474519a"}[chunkId] + ".chunk.js";
};